export default {
  vnc: {
    connecting: "Connecting…",
    disconnect: "Disconnect",
    fullscreen: "Fullscreen",
    exitFullscreen: "Exit Fullscreen",
    status: {
      label: "Status",
      connecting: "Connecting…",
      connected: "Connected",
      disconnected: "Disconnected",
      error: "Connection error",
    },
    errors: {
      connectionFailed: "Failed to connect to the device console.",
    },
  },
  actions: {
    console: "Console",
  },
};
